module.exports = "//d274d294w9cx2v.cloudfront.net/e6f3dc3c160098906fc874f4c87bc6f8a1e31feb/images/photo-couple.png";